<section>
  <div class="header">
    <h1>{{ 'PROFILE_FORM.HEADER' | translate }}</h1>
  </div>
  @if (form) {
    <form class="astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-form-stack">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['name']"></astral-input>
          <astral-input [control]="form.controls['referenceName']"></astral-input>
          <app-org-number class="astral-layout-item" [control]="form.controls['organizationNo']"></app-org-number>
          <astral-input type="email" [control]="form.controls['email']"></astral-input>
          <astral-input type="phone" [control]="form.controls['phone']"></astral-input>
          <app-int-box class="astral-layout-item" [control]="form.controls['hogiaCustomerNumber']"></app-int-box>
        </astral-layout-group>
        <app-postal-address [group]="form.controls['address']" [model]="address" [mandatory]="true"></app-postal-address>
      </section>
      <astral-button variant="primary" type="submit" labelKey="SAVE_BTN"></astral-button>
    </form>
  }
</section>
